import { useState, useEffect } from "react";
import { useAuth0 } from "../../react-auth0-spa";
import { useAppContext } from "../../context";
import { fetchDocsAndCoords } from "./api";
import { buildCoordsIndex, joinDocsWithCoords } from "./utils";

// Carica documenti + coordinate, normalizza la regione in maiuscolo e fa il join client-side.
export const useDocumentsData = () => {
  const { getTokenSilently } = useAuth0();
  const { isProd } = useAppContext();
  const env = isProd ? "prod" : "dev";

  const [docs, setDocs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        setLoading(true);
        const token = await getTokenSilently();
        const { docs: rawDocs, coords } = await fetchDocsAndCoords(token, env);
        const normalized = rawDocs.map((d) => ({
          ...d,
          regione: d.regione ? d.regione.toUpperCase() : d.regione,
        }));
        const idx = buildCoordsIndex(coords);
        if (active) setDocs(joinDocsWithCoords(normalized, idx));
      } catch (e) {
        console.error("Errore caricamento documenti:", e);
        if (active) setError("Errore nel caricamento dei documenti");
      } finally {
        if (active) setLoading(false);
      }
    })();
    return () => {
      active = false;
    };
  }, [getTokenSilently, env]);

  return { docs, loading, error };
};
